<svg width="22" height="22" viewBox="0 0 22 22" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M11 21C16.523 21 21 16.523 21 11C21 5.477 16.523 1 11 1C5.477 1 1 5.477 1 11C1 16.523 5.477 21 11 21Z" stroke="#707070" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14 8C14 6.4 12.667 6 12 6C11.333 6 10 6.4 10 8V11M10 11V13C10 13.667 9.6 15 8 15H14M10 11H12M10 11H8" stroke="#707070" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
